/**
 * --------------------------------------------------------------
 * pengaturan umum
 * nilai yang beda per environment dibaca dari env var VUE_APP_* (lihat .env.example)
 * API_URL : for request data
 * CookiesName : cookies for customer
 * --------------------------------------------------------------
 */
export const baseChatURL = process.env.VUE_APP_BASE_CHAT_URL;
export const BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const API_URL = BASE_URL + "/api";
export const IMAGE_URL = BASE_URL + "/files/images"; // jika beda base tinggal ganti saja
export const FILES_URL = BASE_URL + "/files/file";

/**
 * --------------------------------------------------------------
 * for name cookies
 * --------------------------------------------------------------
 */
export const CookiesClient = "rwClient";

/**
 * --------------------------------------------------------------
 * images app
 * --------------------------------------------------------------
 */
export const image = {
  staff: "img/rw/staff.png",
  customer: "img/rw/customer.png",
  rwlogo: "img/rw/rw.png",
  bot: "img/rw/bot.png",
};

/**
 * --------------------------------------------------
 * konfigurasi untuk pilihan departemen
 * ketika akan register / mulai chat
 * id : id record nya didb
 * --------------------------------------------------
 */
export const departemenStatus = [
  {
    id: 1,
    name: "Sales",
    status: "Online",
  },
  {
    id: 2,
    name: "Billing",
    status: "Online",
  },
  {
    id: 3,
    name: "Technical Support",
    status: "Online",
  },
];

export const clientzone_url = process.env.VUE_APP_CLIENTZONE_URL; // clientzone base url
export const V2_URL = process.env.VUE_APP_V2_URL; // client chat v2

/**
 * --------------------------------------------------------------
 * appMode : "demo" untuk menampilkan debug log dan WidgetDebug
 * cookieCustomerSite : domain cookies customer
 * turnstileSiteKey : site key Cloudflare Turnstile
 * --------------------------------------------------------------
 */
export const appMode = process.env.VUE_APP_MODE;
export const cookieCustomerSite = process.env.VUE_APP_COOKIE_CUSTOMER_SITE;
export const turnstileSiteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY;

/**
 * --------------------------------------------------------------
 * check_connection : true = cek koneksi aktif (pulse + alert timeout)
 * limitMessage : jumlah pesan per halaman di panel staff
 * timeAway : menit sebelum thread dianggap away (default config localStorage)
 * thresholdLimitReadMessageByCron : batas baca pesan lewat cron sebelum alert koneksi
 * thresholdRatingInMinute : menit sebelum rating customer kedaluwarsa
 * --------------------------------------------------------------
 */
export const check_connection = process.env.VUE_APP_CHECK_CONNECTION === "true";
export const limitMessage = Number(process.env.VUE_APP_LIMIT_MESSAGE);
export const timeAway = Number(process.env.VUE_APP_TIME_AWAY);
export const thresholdLimitReadMessageByCron = Number(
  process.env.VUE_APP_THRESHOLD_LIMIT_READ_MESSAGE_BY_CRON
);
export const thresholdRatingInMinute = Number(
  process.env.VUE_APP_THRESHOLD_RATING_IN_MINUTE
);
